import axios from "axios";
import { clearToken, getToken } from "@/lib/authToken";
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

/**
 * Cliente axios para Ekspertium.
 *
 * Auth: cookie httpOnly `ekspertium_auth` (XSS-safe). `withCredentials:true`
 * la envía automáticamente. Como fallback (clientes legacy o requests sin
 * cookie) añadimos el Bearer token desde sessionStorage si existe.
 *
 * En caso de 401, redirigimos al login (excepto en rutas públicas).
 */
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Limpiar caché de bootstrap (sessionStorage) para evitar mostrar al
      // usuario datos de una sesión que ya expiró.
      clearToken();
      try {
        sessionStorage.removeItem("dobilas_user");
      } catch (e) { /* sessionStorage no disponible */ }
      const path = window.location.pathname;
      const isPublic = path.startsWith("/login")
        || path.startsWith("/verify")
        || path.startsWith("/forgot-password")
        || path.startsWith("/reset-password")
        || path.startsWith("/share")        // landing pública del asegurado/perjudicado
        || path === "/";                    // landing marketing
      if (!isPublic) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
